<script>
	import Button from "../../components/Button.svelte";
</script>
<section class="section dispatcher">
	<div class="container">
		<h2 class="h1 dispatcher__title b">For accountants</h2>
		<div class="dispatcher__info">
			<h3 class="block-info__title h3">Accountants Can Also Try Our Free Trucking Dispatch Software</h3>
			<p class="block-info__text h5">Thanks to Loder’s integrated accounting software for trucking companies, accountants no longer need to prepare transportation reports manually.</p>
		</div>
		<div class="dispatcher__row">
			<div class="dispatcher-item">
				<h2 class="dispatcher-item__title b h1">Loder</h2>
				<p class="h6 dispatcher-item__text">Loder automatically registers shipments and cargo information to the accounting department’s software, which reduces the manual work input of accountants and other trucking company staff.</p>
				<img src="../assets/img/Loder-img.png" alt="Loader" class="dispatcher-item__img">
			</div>
			<img src="../assets/svg/from-to.svg" alt="From - To" clsass="dispatcher-item__fromto">
			<div class="dispatcher-item">
				<h2 class="dispatcher-item__title dispatcher-item__title--ezloads b h1">ezLoads</h2>
				<p class="h6 dispatcher-item__text">With this automated accounting software, trucking company owners no longer need to worry about human error, and trucking company accountants are free from tedious manual work.</p>
				<img src="../assets/img/ezLoads-img.png" alt="ezLoads" class="dispatcher-item__img">
			</div>
		</div>
		<div class="dispatcher-footer">
			<h3 class="dispatcher-footer__title h3">The integration provided by Loder’s system automates many tasks related to bookkeeping and keeps company overhead to a minimum.</h3>
			<Button width='150px' label='Sign up' type='outlined dispatcher-footer__button'/>
		</div>
	</div>
</section>

<style>
	.section {
		padding:150px 0 150px ;
		background-color: var(--system-background-primary);
	}
	.container {
		max-width: 1320px;
		width: 100%;
		margin: 0 auto;
		padding: 0px 10px;
		box-sizing: border-box;
	}
	.dispatcher__title {
		color: #169D5C;
		margin: 0;
		display: flex;
		align-items: center;
		margin-left: 52px;
		position: relative;
	}
	.dispatcher__title::after {
		content: '';
		display: block;
		position: absolute;
		left: 20px;
		top: -148px;
		height: 152px;
		border-left: 1px dashed #169D5C;
	}
	.dispatcher__title::before {
		content: '';
		display: block;
		width: 40px;
		height: 40px;
		border-radius: 10px;
		margin-right: 20px;
		background-color: #169D5C;
	}
	.block-info__title {
		position: relative;
		display: flex;
		align-items: flex-start;
		gap: 56px;
		margin: 0;
		max-width: 740px;
		color: var(--color-primary-500);
	}
	.block-info__title::before {
		content: '';
		display: block;
		width: 34px;
		height: 34px;
		min-width: 34px;
		min-height: 34px;
		background: var(--system-background-tertiary);
		border-radius: 50%;
	}
	.block-info__title::after {
		content: '';
		display: block;
		width: 34px;
		height: 34px;
		min-width: 34px;
		min-height: 34px;
		border: 5px solid var(--color-primary-500);
		border-radius: 50%;
		position: absolute;
		left: 12px;
		box-sizing: border-box;
	}
	.block-info__text {
		margin: 35px 0 20px 92px;
		max-width: 740px;
		color: var(--text-color-secondary);
	}
	.dispatcher__info {
		margin: 70px 0 70px 50px;
	}
	.dispatcher__row {
		display: flex;
		gap: 50px;
		justify-content: space-between;
		align-items: center;
	}
	.dispatcher-item {
		border-radius: 20px;
		background: var(--system-background-secondary);
		padding: 45px 80px;
		max-width: 570px;
		width: 100%;
		overflow: hidden;
	}
	.dispatcher-item__title {
		margin: 0;
		color: var(--color-primary-500);
	}
	.dispatcher-item__title--ezloads {
		margin: 0;
		color: #45B17D;
	}
	.dispatcher-item__text {
		margin: 20px 0px 40px;
		color: var(--text-color-secondary);
	}
	.dispatcher-item__img {
		margin: 0 -90px -45px 0;
		display: block;
		width: 490px;
	}
	.dispatcher-footer {
		padding: 35px 75px;
		border-radius: 20px;
		margin-top: 70px;
		display: flex;
		align-items: flex-end;
		gap: 75px;
		background-color: var(--color-primary-500);
	}
	.dispatcher-footer__title {
		color: var(--text-color-white);
	}
	:global(.dispatcher-footer__button) {
		background: transparent !important;
		border: 1px solid var(--text-color-white) !important;
		color:  var(--text-color-white) !important;
		min-width: 125px;
	}
	@media(max-width: 1200px) {
		.container {
			max-width: 1080px;
		}
		.section {
			padding: 120px 0 120px;
		}
		.dispatcher__title {
			font-size: 32px;
			line-height: 40px;
		}
		.block-info__title {
			font-size: 24px;
			line-height: 30px;
			gap: 50px;
		}
		.block-info__text {
			font-size: 16px;
			line-height: 20px;
			margin-left: 86px;
			margin-top: 25px;
		}
		.dispatcher-item {
			padding: 35px 60px;
			max-width: 470px;
		}
		.dispatcher-item__title {
			font-size: 32px;
			line-height: 40px;
		}
		.dispatcher-item__text {
			font-size: 14px;
			line-height: 17px;
		}
		.dispatcher-item__img {
			margin: 0 -60px -35px 0;
			width: 410px;
		}
		.dispatcher-footer__title {
			font-size: 24px;
			line-height: 30px;
		}
	}
	
	@media(max-width: 960px) {
		.container {
			max-width: 755px;
		}
		.dispatcher__row {
			flex-direction: column;
			gap: 24px;
		}
		.dispatcher-item {
			padding: 35px 80px;
			max-width: 620px;
			box-sizing: border-box;
		}
		.dispatcher-item__img {
			width: 540px;
			max-width: 540px;
			margin: 0 -80px -35px 0;
		}
		.dispatcher-item__fromto {
			transform: rotate(90deg);
		}
		.dispatcher-footer {
			background: transparent;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			gap: 25px;
			padding: 0;
		}
		.dispatcher-footer__title {
			color: var(--color-primary-500);
			text-align: center;
			max-width: 480px;
		}
		:global(.dispatcher-footer__button) {
			background: transparent !important;
			border: 1px solid var(--color-primary-500) !important;
			color:  var(--color-primary-500) !important;
		}
	}
	
	@media(max-width: 640px) {
		.dispatcher__title {
			font-size: 24px;
			line-height: 30px;
		}
		.container {
			max-width: 540px;
		}
		.section {
			padding: 100px 0 100px;
		}
		.block-info__title {
			font-size: 20px;
			line-height: 25px;
		}
		.block-info__text {
			font-size: 14px;
			line-height: 17px;
		}
		.dispatcher-footer__title {
			font-size: 20px;
			line-height: 25px;
		}
		.dispatcher-item__title {
			line-height: 30px;
			font-size: 24px;
		}
		.dispatcher-item__text {
			line-height: 14px;
			font-size: 12px;
		}
	}

	@media(max-width: 480px) {
		.container {
			max-width: 360px;
		}
		.dispatcher__title {
			margin-left: 10px;
		}
		.dispatcher__title::after {
			left: 14px;
			top: -70px;
			height: 80px;
		}
		.dispatcher__title::before {
			width: 25px;
			height: 25px;
			border-radius: 5px;
			margin-right: 20px;
		}
		.section {
			padding: 70px 0 70px ;
		}
		.block-info__text {
			margin-left: 0;
		}
		.block-info__title::after, .block-info__title::before {
			display: none;
		}
		.dispatcher-item {
			padding: 35px 20px;
			max-width: 100%;
		}
		.dispatcher__info {
			margin: 40px 0;
		}
	}
</style>